import { Component } from '@lisergia/core'

export default class extends Component {
  declare element: HTMLElement
  declare elements: {
    closest: HTMLElement | null
  }

  constructor({ element }: { element: HTMLElement }) {
    const [closest, delay = 0] = (element.dataset.fade || '').split('|')

    super({
      element,
      elements: closest ? { closest: element.closest(closest) as HTMLElement } : {},
    })

    this.element.style.setProperty('--animation-delay', `${delay}s`)

    this.createObserver()
  }

  declare observer: IntersectionObserver

  createObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.animateIn()
        } else {
          this.animateOut()
        }
      })
    })

    this.observer.observe(this.elements.closest ?? this.element)
  }

  destroyObserver() {
    this.observer.disconnect()
  }

  animateIn() {
    this.element.setAttribute('data-fade-active', '')
  }

  animateOut() {
    this.element.removeAttribute('data-fade-active')
  }

  addEventListeners() {
    this.createObserver()
  }

  removeEventListeners() {
    this.destroyObserver()
  }
}
